import useMUIMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";


export const useMediaQuery = () => {
  const theme = useTheme();
  const isUpMd = useMUIMediaQuery(theme.breakpoints.up("md"));

  return ({
    isUpMd
  });
};